import "rxjs/add/operator/takeUntil";

import {Component, Input, OnDestroy} from "@angular/core";
import {Subject} from "rxjs/Subject";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {IDocument} from "../../interfaces/document.definition";


@Component({
  selector: "nv-block-header",
  templateUrl: "./nv-block-header.component.html"
})


export class NvBlockHeaderComponent implements OnDestroy {
  public readonly: boolean;

  private document: IDocument;
  private userName: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Input() label: string = "";


  constructor(private busService: BusService) {
    this.busService.onDocumentUpdated
      .takeUntil(this.ngUnsubscribe)
      .subscribe(e => this.updateDocument(e))
  }


  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private updateDocument(e: INewDocumentEvent) {
    this.document = e.document;
    this.readonly = e.readonly;
    this.userName = e.user ? e.user.displayName : "system";
  }


  getDocumentLabel(): string {
    return `${this.label}`;
  }

  getDocumentId(): string {
    return this.document ? this.document._id : "";
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-block-header/nv-block-header.component.ts